import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';

export const StreamHeaderErrorView: FC = () => {
  const {t} = useTranslation();

  return (
    <Wrapper data-testid="StreamHeaderErrorView">
      {t('Oops! Something went wrong!')}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: calc(
    100vh - 4rem -4rem - 5rem
  ); /* top space - header height - footer height */
`;
